export const LANDING_PAGE_TEXTS = {
    TITLE: 'landing-page__title',
    SUBTITLE: 'landing-page__subtitle',
    DESCRIPTION: 'landing-page__description',
    SCROLL_LINK: 'landing-page__scroll-link'
};

export enum ANALYTICS_LANDING_FLOW_ACTIONS {
    LANDING_PAGE = 'main landing page',
    DISCOVER = 'discover the program'
}

export const ANALYTICS_LANDING_FLOW_STEP = {
    flowStep: 'main'
};
